<template>
    <a-form :form="form" @submit.prevent="handleSubmit">
        <a-form-item>
            <a-radio-group v-model="form.type" button-style="solid">
                <a-radio-button value="module">{{ $t("modules.module") }}</a-radio-button>
                <a-radio-button value="relation">{{ $t("modules.relation") }}</a-radio-button>
            </a-radio-group>
        </a-form-item>

        <a-row :gutter="16">
            <a-col :span="12">
                <a-form-item :label="$t('modules.displayName')">
                    <a-input v-model="form.displayName" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item :label="$t('modules.icon')">
                    <MaterialIconPicker v-model="form.icon" />
                </a-form-item>
            </a-col>
        </a-row>

        <template v-if="form.type === 'relation'">
            <a-form-item>
                <a-radio-group v-model="form.relation.type" button-style="solid">
                    <a-radio-button value="table-to-table">{{ $t("modules.relationPairTableTable") }}</a-radio-button>
                    <a-radio-button value="table-to-standart" style="display: none;">{{ $t("modules.relationPairTableStandart") }}</a-radio-button>
                    <a-radio-button value="standart-to-table">{{ $t("modules.relationPairStandartTable") }}</a-radio-button>
                </a-radio-group>
            </a-form-item>

            <template v-if="form.relation.type === 'table-to-table'">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-card :title="$t('modules.fromColumn')">
                            <TableConnectionForm v-model="form.relation.tableToTable.from" :tables="tables" />
                        </a-card>
                    </a-col>
                    <a-col :span="12">
                        <a-card :title="$t('modules.toColumn')">
                            <TableConnectionForm v-model="form.relation.tableToTable.to" :tables="tables" />
                        </a-card>
                    </a-col>
                </a-row>
            </template>

            <template v-if="form.relation.type === 'table-to-standart'">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-card :title="$t('modules.fromColumn')">
                            <TableConnectionForm v-model="form.relation.tableToStandart.from" :tables="tables" />
                        </a-card>
                    </a-col>
                    <a-col :span="12">
                        <a-card :title="$t('modules.toColumn')">
                            <StandartModuleConnectionForm
                                v-model="form.relation.tableToStandart.to"
                                :contact-properties="contactProperties"
                            />
                        </a-card>
                    </a-col>
                </a-row>
            </template>

            <template v-if="form.relation.type === 'standart-to-table'">
                <a-row :gutter="16">
                    <a-col :span="12">
                        <a-card :title="$t('modules.fromColumn')">
                            <StandartModuleConnectionForm
                                v-model="form.relation.standartToTable.from"
                                :contact-properties="contactProperties"
                            />
                        </a-card>
                    </a-col>
                    <a-col :span="12">
                        <a-card :title="$t('modules.toColumn')">
                            <TableConnectionForm v-model="form.relation.standartToTable.to" :tables="tables" />
                        </a-card>
                    </a-col>
                </a-row>
            </template>
        </template>

        <template v-if="form.type === 'module'">
            <a-form-item :label="$t('modules.table')">
                <a-select v-model="form.module.table">
                    <a-select-option v-for="table in tables" :key="table._id" :value="table._id">
                        {{ table.name }}
                    </a-select-option>
                </a-select>
            </a-form-item>

            <a-form-item :label="$t('modules.settings')">
                <a-checkbox v-model="form.module.settings.showInMainMenu">
                    {{ $t("modules.showInMainMenu") }}
                </a-checkbox>
                <a-checkbox v-model="form.module.settings.apiEnabled">
                    {{ $t("modules.apiAccess") }}
                </a-checkbox>
            </a-form-item>
        </template>
    </a-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MaterialIconPicker from "../Module/MaterialIconPicker.vue";
import TableConnectionForm from "./components/TableConnectionForm.vue";
import StandartModuleConnectionForm from "./components/StandartModuleConnectionForm.vue";

export default {
    components: {
        MaterialIconPicker,
        TableConnectionForm,
        StandartModuleConnectionForm,
    },
    props: {
        defaultMode: {
            type: String,
            default: "module",
        },
    },
    data() {
        return {
            form: {
                type: this.defaultMode,
                displayName: "",
                description: "",
                icon: "",

                module: {
                    table: null,
                    settings: {
                        showInMainMenu: true,
                        apiEnabled: true,
                    },
                },

                relation: {
                    type: "table-to-table",

                    tableToTable: {
                        from: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                        to: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                    },

                    tableToStandart: {
                        from: {
                            table: null,
                            connectionType: "field",
                            field: null,
                        },
                        to: {
                            module: "contact",
                            connectionType: "field",
                            field: "_id",
                        },
                    },

                    standartToTable: {
                        from: {
                            module: "contact",
                            connectionType: "field",
                            field: "_id",
                        },
                        to: {
                            table: null,
                            connectionType: "_id",
                            field: null,
                        },
                    },
                },
            },
        };
    },
    created() {
        this.form.type = this.defaultMode;
    },
    computed: {
        ...mapState({
            tables: (state) => state.table.tables,
            contactProperties: (state) => state.contactProperty.data,
        }),
    },
    methods: {
        ...mapActions({
            createModule: "module/createModule",
            syncModules: "module/syncModules",
        }),
        async handleSubmit() {
            try {
                await this.createModule(this.form);
                this.$message.success(this.$t("modules.createSuccess"));
                this.$emit("success");
                this.syncModules();
            } catch (error) {
                this.$message.error(this.$t("modules.createFailed"));
            }
        },
    },
};
</script>
